<template>
  <v-container fluid class="container-full-bg-gray">
    <div>
    <MassiveChangesPopUp
      v-if="massiveDialog"
      :dialog="massiveDialog"
      @close-popup="cancelMassiveChanges()"
      @save-massive-changes="doMassiveChanges()"
    >
      <template v-slot:inputs>
      </template>
    </MassiveChangesPopUp>


    <app-modal-prompt
      v-model="massiveAddLinkDialog"
      width="700"
      :is-confirm-button-disabled="!can_create_line"
      @cancel="massiveAddLinkDialog = false"
      @confirm="massiveAddLink"
    >
      <template #title>
        Crear ejercicio para las empresas seleccionadas
      </template>
      <app-modal-row v-if="user_data_available_features['feature_periodo_ejercicio']">
        <app-modal-col cols="4" class="pr-2">
          <app-date-picker
            aucomplete="off"
            v-model="start_ejercicio" 
            label="Fecha inicio ejercicio"
          ></app-date-picker>
        </app-modal-col>
        <app-modal-col cols="4" class="pl-2 pr-2">
          <app-date-picker
            aucomplete="off"
            v-model="end_ejercicio" 
            label="Fecha fin ejercicio"
          ></app-date-picker>
        </app-modal-col>
        <app-modal-col cols="4" class="pl-2">
          <app-text-field
            label="Año ejercicio"
            type="number"
            v-model="year_ejercicio"
          ></app-text-field>
        </app-modal-col>
      </app-modal-row>
      
      <app-modal-row>
        <app-modal-col :cols="user_data_available_features['feature_periodo_ejercicio'] ? '4': '6'" class="pr-2">
          <app-date-picker
            aucomplete="off"
            v-model="min_date" 
            label="Fecha mínima de las facturas"
          ></app-date-picker>
        </app-modal-col>
        <app-modal-col :cols="user_data_available_features['feature_periodo_ejercicio'] ? '4': '6'" class="pl-2">
          <app-date-picker
            aucomplete="off"
            v-model="max_date" 
            label="Fecha máxima de las facturas"
          ></app-date-picker>
        </app-modal-col>
      </app-modal-row>
    </app-modal-prompt>

    <app-modal-prompt 
      v-model="massiveChangeLinkDialog" 
      :is-confirm-button-disabled="false"
      @cancel="massiveChangeLinkDialog = false" 
      @confirm="massiveChangeLink" 
      persistent width="900"
    >
        <template #title>
          <span v-if="user_data_available_features['feature_periodo_ejercicio']">Cambiar fecha máxima de las facturas de forma masiva</span>
          <span v-else>Cambiar fecha límite de un ejercicio de forma masiva</span>
        </template>
          <app-modal-row>
            <app-modal-col cols="3">
              <app-select
              v-model="change_link_type"
              :items="link_type_items"
              item-key="value"
              item-text="name"
              label="Límite a editar"
              >
              </app-select>
            </app-modal-col>
            <app-modal-col cols="3" class="px-2">
              <app-select
                outlined
                v-model="change_link_year"
                :items="computed_link_year_items"
                label="Año del ejercicio"
              >
              </app-select>
            </app-modal-col>
            <app-modal-col cols="6">
              <app-date-picker
                aucomplete="off"
                v-model="new_link_date" 
                label="Nueva fecha límite" 
              ></app-date-picker>
            </app-modal-col>
          </app-modal-row>        
    </app-modal-prompt>

    <!-- Popup 'Descargar CSV' para elegir fechas -->
    <app-modal-prompt 
      v-if="user_data_available_features['feature_csv_multiple_companies']"
      v-model="downloadMassiveCsvDialog"
      :is-confirm-button-disabled="disable_confirm_csv_download"
      @cancel="downloadMassiveCsvDialog = false"
      @confirm="downloadMassiveCSV"
      :confirmBtnText="'Descargar'"
      persistent width="600"
    >
      <template #title>
        Descargar CSV de las empresas selecccionadas
      </template>
        <app-modal-row style="font-size: 16px; font-weight: 500; line-height: 40px;">Rango de fechas de subida de facturas</app-modal-row>
        <app-modal-row>
          <app-modal-col cols="6" class="pr-1">
            <app-date-picker
              label="Fecha de inicio"
              v-model="csv_date_range.start"
              aucomplete="off"
            ></app-date-picker>
          </app-modal-col>
          <app-modal-col cols="6" class="pl-1">
            <app-date-picker
              label="Fecha de fin"
              v-model="csv_date_range.end"
              aucomplete="off"
            ></app-date-picker>
          </app-modal-col>
        </app-modal-row>
        <app-modal-row style="font-size: 14px; font-weight: 325">(Seleccione al menos una fecha)</app-modal-row>

    </app-modal-prompt>

    <!-- Popup 'Emitir confirmación de recepción de emails de puntos de carga' -->
    <app-modal-prompt 
      v-model="updateMassiveConfirmationMailDialog"
      @cancel="updateMassiveConfirmationMailDialog = false"
      @confirm="updateMassiveConfirmationMail()"
      :confirmBtnText="'Actualizar'"
      persistent width="650"
    >
      <template #title>
        Emitir confirmación de recepción de emails (Puntos de carga)
      </template>
        <app-modal-row style="font-size: 16px; font-weight: 500; line-height: 20px;">Activar / Desactivar</app-modal-row>
        <app-modal-row>
          <app-modal-col cols="12">
            <!-- Radio buttons Activar/Desactivar -->
            <v-radio-group column v-model="updateConfirmationMail_newValue">
              <v-radio label="Activar" :value="true"></v-radio>
              <v-radio label="Desactivar" :value="false"></v-radio>
            </v-radio-group>
          </app-modal-col>
        </app-modal-row>
    </app-modal-prompt>

    <!-- Popup 'Archivar / Habilitar empresas' -->
    <app-modal-prompt v-if="user_data_available_features['feature_archive_companies']"
      v-model="showMassiveUpdateIsArchivedDialog"
      @cancel="showMassiveUpdateIsArchivedDialog = false"
      @confirm="runMassiveUpdateIsArchived()"
      :confirmBtnText="'Confirmar'"
      persistent width="650"
    >
      <template #title>
        Archivar / Habilitar empresas
      </template>
        <app-modal-row style="font-size: 16px; font-weight: 500; line-height: 20px;">Seleccione la acción a realizar</app-modal-row>
        <app-modal-row>
          <app-modal-col cols="12">
            <v-radio-group column v-model="massiveUpdateIsArchived_newValue">
              <v-radio label="Archivar empresas" :value="true">
                <template v-slot:label>
                  <span class="radio-label-with-icon">Archivar <v-icon color="grey">mdi-archive-outline</v-icon></span>
                </template>
              </v-radio>
              <v-radio label="Habilitar empresas" :value="false">
                <template v-slot:label>
                  <span class="radio-label-with-icon">Habilitar <v-icon color="green">mdi-check-circle-outline</v-icon></span>
                </template>
              </v-radio>
            </v-radio-group>
          </app-modal-col>
        </app-modal-row>
    </app-modal-prompt>

    <app-modal-prompt
      v-model="massiveDeactivateLinkDialog"
      :is-confirm-button-disabled="!year_to_deactivate"
      @cancel="massiveDeactivateLinkDialog = false"
      @confirm="massiveDeactivateLink" 
      persistent width="600"
    >
      <template #title>
        Desactivar ejercicio para las empresas seleccionadas
      </template>
      <app-modal-row>
        <app-modal-col cols="12">
          <app-text-field
            label="Año del ejercicio a desactivar (YYYY)"
            v-model="year_to_deactivate"
          />
        </app-modal-col>
      </app-modal-row>
    </app-modal-prompt>

    <app-modal-prompt
      v-model="errorDialog"
      confirm-btn-text="Aceptar"
      :show-cancel-btn="false"
      @confirm="errorDialog = false"
    >
      <template #title>Error</template>
      <app-row>
        <app-col cols="12">
          <app-confirm-modal-title show-title text-title="Se han producido los siguientes errores" />
        </app-col>
      </app-row>    
      <app-row>
        <v-card-text>
          <ul>
            <div v-for="err in errors" :key="err">
              <li>
                <p>{{err}}</p>
              </li>
            </div>
          </ul>
        </v-card-text>
      </app-row>
    </app-modal-prompt>

    <v-dialog v-model="massiveConnectorCreationDialog" max-width="660">
      <v-card class="rounded-lg">
        <v-card-title>
          <span class="text-h6 primary--text">Carga de empresas por fichero excel</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container class="px-7">
            <v-row>
              <v-col align="center" class="pb-0">
                  <AppIcon src="/icon_table.svg" :size="39" />
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <span class="text-h6 primary--text">Orden Cabecera</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <p class="mb-0">Necesitamos la siguiente estructura</p>
                <p class="font-weight-bold">Tipo / Fecha mínima de las facturas / Fecha máxima de las facturas / Código de la empresa</p>
              </v-col>
            </v-row>
    
            <span>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    class="rounded-lg"
                    label="Archivo"
                    v-model="massiveConnectorCreationFile"
                    prepend-icon="mdi-paperclip"
                    color="primary"
                    accept=" .xls, .xlsx, .xlsm, .ods"
                    :clearable="false"
                    :loading="loadingMassiveConnectorCreation"
                    :rules="[v => !!v || 'Archivo requerido']"
                    outlined
                  ></v-file-input>
                </v-col>
              </v-row>
            </span>
          </v-container>
        </v-card-text>
      <v-card-actions class="mr-4">
          <v-spacer></v-spacer>
          <app-btn outlined @click="massiveConnectorCreationDialog = false; massiveConnectorCreationFile = null;">Cancelar</app-btn>
          <app-btn 
            color="primary" 
            @click="massiveConnectorCreation()" 
            variant="text"
            :disabled="!massiveConnectorCreationFile"
            :loading="loadingMassiveConnectorCreation"
          >
            Subir
          </app-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.isVisible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
        {{ snackbar.text }}
    </v-snackbar>


    <ListObject
      :objectType="objectType"
      :url="url"
      :selectRow="selectRow"
      :headers="headers"
      :create="create"
      :itemClass="getItemClass"
      :canCreate="permission.general.can_admin"
      :filtersData="filtersData"
      :deleteMsg="deleteMsg"
      :errorMsg="errorMsg"
      :rowsNumber="rowsPerPage"
      @rowsPerPage="setRowsNumber"
      :generateFilters="genFilters" 
      :cleanFilters="cleFilters"
      :refreshData="refresh"
      :filters="currentFilters"
      :selectionableRows="true"
      @item-selected="send_filters = false"

      @job-done="jobDone"
      @selected-action="selectedAction"
      :actions="getActions" 
      :loadingAction="loadingAction"
      :disabledActions="selected.length==0"
    >
      <template v-slot:mid_btns>
        <v-btn 
          color="primary"
          icon 
          v-if="user_data_available_features['feature_company_massive_creation']"
          @click="massiveConnectorCreationDialog=true;"
          >
          <v-icon>upload_file</v-icon>                  
        </v-btn>
      </template>

      <template v-slot:actions>
        <!-- <action-selector 
          
          @do-action="doAction"
          @job-done="jobDone"
          @selected-action="selectedAction"
        ></action-selector> -->
      </template>
      
      <template v-slot:select_all>
        <v-checkbox
          v-if="show_select_all"
          :label="'Aplicar en las ' + length_items + ' empresas'"
          class="ma-0 pt-2 pl-4 pb-2 pr-0" 
          v-model="send_filters"
          hide-details
        ></v-checkbox>
      </template>

      <template v-slot:filters>
        <v-row>
          <v-col cols="12">
            <div>
              <v-text-field 
                autocomplete="off" 
                :label="con_filters_company__name__icontains.label" 
                v-model="con_filters_company__name__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-text-field 
                autocomplete="off" 
                :label="con_filters_company__nif__icontains.label" 
                v-model="con_filters_company__nif__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-text-field
                autocomplete="off"
                :label="con_filters_name__icontains.label"
                v-model="con_filters_name__icontains_value"
                v-on:keyup.enter="genFilters"
              ></v-text-field>
              <v-select
                label="Estado"
                v-model="stateFilter"
                :items="stateFilterOptions"
                @change="genFilters"
              ></v-select>
              <v-select
                label="Tipo"
                v-model="typeFilter"
                :items="typeFilterOptions"
                @change="genFilters"
              ></v-select>
              <v-select v-if="user_data_available_features['feature_archive_companies']"
                label="Activas / Archivadas"
                v-model="archiveFilter"
                :items="[
                  { text: 'Todas', value: 'all' },
                  { text: 'Activas', value: 'active' },
                  { text: 'Archivadas', value: 'archived' }
                ]"
                @change="genFilters"
              ></v-select>
            </div>
          </v-col>
        </v-row>
      </template>
    </ListObject>
    </div> 
  </v-container>
</template>

<script>
import ListObject from '../components/ListObject.vue';
import ActionSelector from '../components/ActionSelector.vue';
import MessagePopup from '../components/MessagePopup.vue';
import MassiveChangesPopUp from '../components/MassiveChangesPopUp.vue';
import AppBtn from '@/components/layout/AppBtn.vue';
import AppConfirmModalTitle from '@/components/layout/AppConfirmModalTitle.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppDatePicker from '@/components/layout/AppDatePicker.vue';
import { mapActions, mapState, mapGetters } from 'vuex';
import { client, async_command_dispatcher } from "@/api/client";
// import connector from "../store/modules/connector";
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix, vuexPrefix2 } from "../store/vuex_utils";
import { jobs } from '../api/jobs.js';
import { DownloadMassiveCSVCommand } from "@/modules/invoices/app/DownloadMassiveCSVCommand";
import { ToDoneCompanyCsvInvoicesCommand } from '@/modules/invoices/app/ToDoneCompanyCsvInvoicesCommand';
import { SetCdbLoadPathsConfirmationMailCommand } from '@/modules/load_path/app/SetCdbLoadPathsConfirmationMailCommand';
import { MultipleForceDownloadLoadPathFilesCommand } from "@/modules/load_path/app/MultipleForceDownloadLoadPathFiles";
import { MassiveUpdateIsArchivedCommand } from "@/modules/company/app/MassiveUpdateIsArchivedCommand";
import { doActionUtils } from '@/modules/connector/domain/connectorListUtils';

export default {
  components: {
    ListObject,
    ActionSelector,
    MessagePopup,
    MassiveChangesPopUp,
    AppDatePicker,
    AppBtn,
    AppConfirmModalTitle,
    AppModalCol,
    AppModalPrompt,
    AppModalRow,
    AppSelect,
    AppTextField,
    AppModalPrompt
    },
  data() {
    return {
      objectType: "Empresas",
      url: "companydbs_lite/",
      create: "create-connector",
      update: "connector-update",
      headers:[
        {text: "Id", value: "id", width: 60},
        {text: "Nombre de empresa", value: "name" ,width: 160},
        {text: "CIF Empresa", value: "cif" ,width: 160},
        {text: "Ruta", value: "path", width: 160, sortable: false},
        {text: "Estado", value: "last_operation_state", width: 160, sortable: false},
        {text: "Tipo", value: "companydb_type.name", width: 160, sortable: false},
        // {text: "Archivada", value: "is_archived_label", width: 80, sortable: false} --- Added in created() only if 'feature_archive_companies'
      ],
      filtersData: [
        {
          'name': 'company__name__icontains', 
          'label': 'Nombre de empresa'
        },
        {
          'name': 'company__nif__icontains', 
          'label': 'CIF de empresa'
        },
        {
          'name': 'name__icontains', 
          'label': 'Ruta'
        }
      ],
      // deleteMsg: "You will remove this company. Are you sure?",
      // errorMsg: "It was not possible to delete this company.",
      deleteMsg: "¿Estás seguro de que quieres borrar esta empresa?",
      errorMsg: "No se ha podido borrar esta empresa.",

      send_filters: false,
      loadingAction: false,
      selected_action: '',
      ids: [],

      message: '',
      show_message: false,
      deleteDialog: false,
      massiveDialog: false,
      isEnabled: {},
      massiveAddLinkDialog: false,
      min_date: '',
      max_date: '',
      start_ejercicio: '',
      end_ejercicio: '',
      year_ejercicio: '',
      massiveChangeLinkDialog: false,
      change_link_type: 'max_date',
      link_type_items: [{'value':'max_date','name':'Fecha máxima'},{'value':'min_date','name':'Fecha mínima'}],
      change_link_year: '2022',
      new_link_date:'2022-12-31',
      // *** vars for download massive csv
      downloadMassiveCsvDialog: false,
      csv_date_range: {start: undefined, end: undefined},
      updateMassiveConfirmationMailDialog: false,
      updateConfirmationMail_newValue: true,
      // ^^^
      massiveDeactivateLinkDialog: false,
      year_to_deactivate: '',
      errors: [],
      errorDialog: false,
      snackbar: {
        isVisible: false,
        text: '',
        color: '',
        timeout: 2000,
      },
      textSnackbarOk: 'Cambios realizados con éxito.',
      //textSnackbarKo: 'Compruebe que los valores en el formulario son válidos.',
      //textSnackbarKoApi: 'Ha habido un problema con la operación.',
      documentName: '',
      documentFormat: '',
      massiveConnectorCreationDialog: false,
      massiveConnectorCreationFile: null,
      loadingMassiveConnectorCreation: false,
      showMassiveUpdateIsArchivedDialog: false,
      massiveUpdateIsArchived_newValue: true,
      archiveFilter: 'all',
      stateFilter: 'all',
      typeFilter: 'all',
    }
  },
  created() {
    this.addRefreshAccountsAction();
    this.addMassiveCompanyDBLinkAction();
    this.changeMassiveCompanyDBLinkAction();
    this.setCompanyDBTypes();
    this.downloadJobState = 'done';
    this.asyncJobId = 0;
    if (this.user_data_available_features['feature_archive_companies']) {
      this.headers.push({text: "Archivada", value: "is_archived_label", width: 80, sortable: false})
    }
  },
  computed: {
    ...mapGetters({
      rowsPerPage: "connector/rowsPerPage",
      permission: 'permissions/permission',
    }),
    ...mapFields({
      page: 'objectListOptions.page',
      selected: 'objectListSelected',
      items: 'objectListItems',
      length_items: 'objectListItemsLength',
      downloadJobState: 'downloadJobState',
      asyncJobId: 'asyncJobId',
      total_length_items: 'totalLengthItems',
    }),
    ...mapFields('connector', {
      currentFilters: 'currentFilters',
      actions: 'actions',
      companydb_types: 'companydb_types',
    }),
    ...mapFields('connector',vuexPrefix('con_filters_',['company__name__icontains', 'company__nif__icontains', 'name__icontains'],'filtersData.')),
    ...mapFields('connector',vuexPrefix2('con_filters_', ['value'], 'filtersData.', ['company__name__icontains', 'company__nif__icontains', 'name__icontains'])),
    ...mapFields('connector',vuexPrefix('connector_', ['links', ], 'connector.')),
    ...mapFields('me', ['userData']),
    ...mapFields('me',vuexPrefix('user_data_', ['available_features', ], 'userData.')),

    stateFilterOptions() {
      return [
        { text: 'Todos', value: 'all' },
        { text: 'Configurando...', value: 'Configurando...' },
        { text: 'Configurado', value: 'Configurado' },
        { text: 'Error', value: 'Error' },
        { text: 'Sin estado', value: 'none' },
      ];
    },
    typeFilterOptions() {
      const options = [{ text: 'Todos', value: 'all' }];
      if (this.companydb_types) {
        for (const t of this.companydb_types) {
          options.push({ text: t.name, value: t.name });
        }
      }
      return options;
    },
    show_select_all() {
      let show = false;
      return show;
    },
    can_create_line() {
      let can = true;
      if (!this.min_date || !this.max_date || !this.start_ejercicio || !this.end_ejercicio || !this.year_ejercicio) {
        return false;
      }
      if (this.max_date <= this.min_date) {
        return false;
      }
      if (this.end_ejercicio <= this.start_ejercicio) {
        return false;
      }
      const year = this.year_ejercicio + '';
      const start_year = this.start_ejercicio.split('-')[0];
      const end_year = this.end_ejercicio.split('-')[0];
      if ([start_year, end_year].indexOf(year) == -1) {
        return false;
      }
      return can;
    },
    computed_link_year_items(){
      let year = parseInt(new Date().getFullYear())
      let i=-8
      let items = []
      while( i <= 8 ){
        const v = (year+i).toString()
        items.push({
          value: v, 
          text: v,
        })
        i+=1
      }
      return items
    },
    getActions() {
      let actions = {};
      for (let i in this.actions) {
        let group = this.actions[i]['group'];
        if (!actions.hasOwnProperty(group)) {
          actions[group] = [];
        }
        let keys = Object.keys(this.actions[i]);
        if (!keys.includes('is_staff') && !keys.includes('loginas') && !keys.includes('feature')) {
          actions[group].push(this.actions[i]);
        } else if (keys.includes('feature')) {
          if (this.user_data_available_features && this.user_data_available_features[this.actions[i]['feature']]) {
            let push_action = true;
            if (keys.includes('admin_owner')) {
              const user_role = this.userData.user_role.value;
              if (user_role != 'admin' && user_role != 'owner') {
                push_action = false;
              }
            }
            if (push_action) actions[group].push(this.actions[i]);
          }
        }
      }
      Object.keys(actions).forEach(function(key) {
        if (actions[key].length == 0) {
          delete actions[key];
        }
      });
      return actions;
    },
    disable_confirm_csv_download() {
      return this.csv_date_range.start == null && this.csv_date_range.end == null
    },
    length_items_without_filters() {
      return this.total_length_items; //viene del backend
    },
  },
  methods: {
    ...mapActions({ 
      refreshData: "refreshData",

      setRowsPerPage: "connector/setRowsPerPage",

      generateFilters: "connector/generateFilters",
      cleanFilters: "connector/cleanFilters",
      exportConn: "connector/exportConn",
      refreshAccounts: "connector/refreshAccounts",
      addRefreshAccountsAction: "connector/addRefreshAccountsAction",
      addMassiveCompanyDBLinkAction: "connector/addMassiveCompanyDBLinkAction",
      changeMassiveCompanyDBLinkAction: "connector/changeMassiveCompanyDBLinkAction",
      massiveUpdate: "connector/massiveUpdate",
      massiveAddCompanyDBLink: "connector/massiveAddCompanyDBLink",
      massiveChangeCompanyDBLink: "connector/massiveChangeCompanyDBLink",
      massiveDeactivateCompanyDBLink: "connector/massiveDeactivateCompanyDBLink",
      massiveCreateConnectors: "connector/massiveCreateConnectors",
      setCompanyDBTypes: "connector/setCompanyDBTypes",
      setCompanydbs2: "setCompanydbs2",
      setMessageModal: 'messageModal/setModal',
      closeMessageModal: 'messageModal/closeModal',
      exportCru: "cru/exportCru",
    }),
    showMessage(m, icon){
      const modal = {
        text: m,        
        actionConfirmButton: this.closeMessageModal,
      }

      if (icon) {
        modal.icon = icon
      }

      this.setMessageModal(modal)
    },
    getItemClass(item) {
      return item.is_archived === true && this.archiveFilter === 'all' ? 'row-archived' : '';
    },
    selectRow(data) {
      //this.$store.dispatch('configuration/setForceRightBar',true);
      var params = { name: this.update, params: { 'id': data.id } };
      this.$router.push(params);
    },
    setRowsNumber(rowsNumber) {
      this.setRowsPerPage(rowsNumber)
    },
    setSnackbar(color, text) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.isVisible = true;
    },

    genFilters() {
      this.generateFilters().then(() => {
        if (this.stateFilter !== 'all') {
          this.currentFilters += '&last_operation_state=' + encodeURIComponent(this.stateFilter);
        }
        if (this.typeFilter !== 'all') {
          this.currentFilters += '&companydb_type__name=' + encodeURIComponent(this.typeFilter);
        }
        if (this.archiveFilter === 'active') {
          this.currentFilters += '&is_archived=false';
        } else if (this.archiveFilter === 'archived') {
          this.currentFilters += '&is_archived=true';
        }
        this.page = 1;
        this.refresh();
      });
    },
    cleFilters() {
      this.stateFilter = 'all';
      this.typeFilter = 'all';
      this.archiveFilter = 'all';
      this.cleanFilters().then(() => {
        this.page = 1;
        this.refresh();
      });
    },
    refresh() {
      this.refreshData(this.currentFilters);
    },

    selectedAction(actionId) {
      this.selected_action = actionId;
      this.doAction();
    },
    doAction() {
      doActionUtils(this);
    },
    async jobDone() {
      if (this.selected_action == 'download_excel_companydbs') {
        const response = await jobs.getJobFile({ id: this.asyncJobId });
        let fileURL = response.data.url;
        this.download_from_url(fileURL, this.documentName + "." + this.documentFormat)
        /*
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", this.documentName + "." + this.documentFormat);
        document.body.appendChild(fileLink);
        fileLink.click();
        */
        this.ids = [];
        this.selected = [];
      }
    },

    
    deleteItems() {
      this.closeMessageModal()
      this.loadingAction = true;
      this.exportConn({ url: 'delete_companydbs/', ids: this.ids }).then(response=>{
        this.loadingAction = false;
        this.selected = [];
        let errs = response.data['errors'];
        if (errs.length) {
          let msg = '';
          for (let i in errs) {
            msg = msg + errs[i] + '<br/>';
          }
          this.showMessage(msg);
        } else {
          this.showMessage('Empresas borradas correctamente.', 'mdi-information-outline');
        }
        this.setCompanydbs2();
        this.refresh();
      }).catch(err=>{
        this.showMessage('Algo ha ido mal.')
        this.loadingAction = false;
        console.error(err);
      });
    },
    noDeleteItems() {
      this.selected = [];
      this.closeMessageModal()
    },
    cancelMassiveChanges() {
      this.massiveDialog = false;
    },
    doMassiveChanges() {
      this.loadingAction = true;
      let params = {};
      this.massiveUpdate({ 
        'ids': this.ids,
        'params': params, 
      }).then(() => {
        this.cancelMassiveChanges();
        this.refresh();
        this.loadingAction = false;
      }).catch(err => {
        console.error(err);
        this.showMessage('Algo ha ido mal')
        this.loadingAction = false;
      });
    },
    massiveAddLink() {
      this.errors = [];
      let do_action = true;
      let error_msgs = [];
      for (let i in this.selected) {
        if (this.selected[i].companydb_type && 'params' in this.selected[i].companydb_type && 'disable_massive_add_link_action' in this.selected[i].companydb_type.params) {
          do_action = false;
          if (!error_msgs.includes(this.selected[i].companydb_type.params['disable_massive_add_link_action'])) {
            error_msgs.push(this.selected[i].companydb_type.params['disable_massive_add_link_action']);
          }
        }
      }
      if (do_action) {
        this.loadingAction = true;
        this.massiveAddCompanyDBLink({
          'ids': this.ids,
          'min_date': this.min_date,
          'max_date': this.max_date,
          'start_ejercicio': this.start_ejercicio,
          'end_ejercicio': this.end_ejercicio,
          'year_ejercicio': this.year_ejercicio
        }).then(resp => {
          this.massiveAddLinkDialog = false;
          if (resp.data['errors'].length) {
            this.errors = resp.data['errors'];
            this.errorDialog = true;
          }
          else {
            this.setSnackbar('success', this.textSnackbarOk);
          }
          this.refresh();
          this.loadingAction = false;
        }).catch(err => {
          this.massiveAddLinkDialog = false;
          console.error(err);
          this.showMessage('Algo ha ido mal.');
          this.loadingAction = false;
        });
      } else {
        let error_msg = ''
        for (let i in error_msgs) {
          error_msg = error_msg + error_msgs[i] + '</br>';
        }
        this.massiveAddLinkDialog = false;
        this.showMessage(error_msg);
      }
    },
    massiveChangeLink() {
      this.loadingAction = true;
      this.massiveChangeCompanyDBLink({
        'ids': this.ids,
        'type': this.change_link_type,
        'year': this.change_link_year,
        'date': this.new_link_date,
      }).then(resp => {
        this.massiveChangeLinkDialog = false;
        if (resp.data['errors'].length) {
          this.errors = resp.data['errors'];
          this.errorDialog = true;
        }
        else {
          this.setSnackbar('success', this.textSnackbarOk);
        }
        this.refresh();
        this.loadingAction = false;
      }).catch(err => {
        this.massiveChangeLinkDialog = false;
        console.error(err);
        this.showMessage('Algo ha ido mal.');
        this.loadingAction = false;
      });
    },
    massiveDeactivateLink() {
      this.errors = [];
      this.loadingAction = true;
      this.massiveDeactivateCompanyDBLink({
        'ids': this.ids,
        'year': this.year_to_deactivate,
      }).then(resp => {
        this.massiveDeactivateLinkDialog = false;
        if (resp.data['errors'].length) {
          this.errors = resp.data['errors'];
          this.errorDialog = true;
        }
        else {
          this.setSnackbar('success', this.textSnackbarOk);
        }
        this.refresh();
        this.loadingAction = false;
      }).catch(err => {
        this.massiveDeactivateLinkDialog = false;
        console.error(err);
        this.showMessage('Algo ha ido mal.');
        this.loadingAction = false;
      });
      
    },
    massiveConnectorCreation() {
      this.loadingMassiveConnectorCreation = true;
      this.massiveCreateConnectors({
        'file': this.massiveConnectorCreationFile
      }).then(resp => {
        this.massiveConnectorCreationDialog = false;
        if (resp.data['errors'].length) {
          this.errors = resp.data['errors'];
          this.errorDialog = true;
        }
        else {
          this.setSnackbar('success', this.textSnackbarOk);
        }
        this.refresh();
        this.loadingMassiveConnectorCreation = false;
      }).catch(err => {
        this.massiveConnectorCreationDialog = false;
        console.error(err);
        this.showMessage('Algo ha ido mal.');
        this.loadingMassiveConnectorCreation = false;
      });
    },
    getCsvCompanies() {
      let csv_ids = [];
      let found = false
      for (const cdb of this.selected) {
        if (cdb.companydb_type.name === "CSV Facturas") csv_ids.push(cdb.id)
        else found = true
      }
      return {ids: csv_ids, allCsv: !found}
    },
    async downloadMassiveCSV() {
      this.loadingAction = true
      this.downloadMassiveCsvDialog = false

      let companies = this.getCsvCompanies()
      if (companies.ids.length == 0) this.showMessage('No se han seleccionado empresas de tipo CSV Facturas')
      else {
        if (!companies.allCsv) this.showMessage('Se descargará el CSV solo de las empresas tipo CSV Facturas')
        // download CSV
        let cmd = new DownloadMassiveCSVCommand()
        let cmd_output = await cmd.run(companies.ids, this.csv_date_range)
        if (typeof cmd_output === "object") {
          if (!cmd_output) {
            this.showMessage("La consulta no ha devuelto ningún resultado")
          }
          else {
            this.showMessage("Se ha producido un error")
          }
        }
        else if (typeof cmd_output === "string") {
          let url = cmd_output
          this.download_from_url(url, "facturas.csv")
        }
      }
      this.loadingAction = false
    },
    async updateMassiveConfirmationMail() {
      this.loadingAction = true
      this.updateMassiveConfirmationMailDialog = false
      // update confirmation_mail value
      let cmd = new SetCdbLoadPathsConfirmationMailCommand()
      let cmd_output = await cmd.run(this.ids, this.updateConfirmationMail_newValue)
      if (!cmd_output) {
        this.showMessage("No se ha realizado ningún cambio")
      }
      else {
        this.showMessage("Cambio realizado")
      }
      this.loadingAction = false
    },
    updateMassiveLoadPaths() {
      this.loadingAction = true
      let cmd = new MultipleForceDownloadLoadPathFilesCommand(async_command_dispatcher)
      let cmd_output = cmd.run(this.ids, 'massive_update')
      this.showMessage("Se ha ejecutado la actualización de los puntos de carga. Esta operación puede tardar varios minutos en finalizar.")
      this.loadingAction = false
    },
    async runMassiveUpdateIsArchived() {
      this.showMassiveUpdateIsArchivedDialog = false
      this.loadingAction = true
      const err_msg = "Algo ha ido mal al actualizar las empresas."

      try {
        let cmd = new MassiveUpdateIsArchivedCommand()
        let res = await cmd.run(this.ids, this.massiveUpdateIsArchived_newValue)
        if (!res) {
          throw new Error(err_msg)
        }
        const msg_option = this.massiveUpdateIsArchived_newValue ? 'archivadas' : 'habilitadas'
        this.showMessage('Las empresas seleccionadas han sido ' + msg_option + '.', 'mdi-information-outline')
      }
      catch(err) {
        console.error(err)
        this.showMessage(err_msg)
      }
      finally {
        this.selected_action = ''
        this.loadingAction = false
        this.refresh()
      }
    },
    async run_command(cmd) {
      let cmd_output = await cmd.run()
      if (typeof cmd_output === "object") {
        if (!cmd_output) {
          this.showMessage("La consulta no ha devuelto ningún resultado")
        }
        else {
          this.showMessage("Se ha producido un error")
        }
        return null
      }
      else {
        return cmd_output
      }
    },
    async toDoneCompanyCsvInvoices() {
      this.loadingAction = true

      let companies = this.getCsvCompanies()
      if (companies.ids.length == 0) this.showMessage('No se han seleccionado empresas de tipo CSV Facturas')
      else {
        if (!companies.allCsv) this.showMessage('Se contabilizarán solo las facturas de las empresas tipo CSV Facturas')
        let cmd = new ToDoneCompanyCsvInvoicesCommand(companies.ids)
        let cmd_output = await this.run_command(cmd)
        console.log("output", cmd_output)
        if (typeof cmd_output === "boolean") {
          if (cmd_output) this.showMessage('Se han contabilizado las facturas')
          else this.showMessage('No se han encontrado facturas para contabilizar')
        }
        else this.showMessage('Se ha producido un error')
      }
      this.loadingAction = false
    },
    async download_from_url(url, full_file_name) {
      const response = await fetch(url);
      const blob = await response.blob();
      // For other browsers: create a link pointing to the ObjectURL containing the blob.
      const objUrl = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = objUrl;
      link.download = full_file_name;
      link.click();
      // For Firefox it is necessary to delay revoking the ObjectURL
      setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
    }
  },
};
</script>

<style lang="scss" scoped>
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .primary-border {
    border-color: var(--v-primary-base) !important;
  }
  .radio-label-with-icon {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 100px;
  }
</style>
<style>
  .row-archived {
    color: #c0c0c0 !important;
  }
</style>